import OrderCostSummaryV4 from "../OrderCostSummaryV4";

const OrderCostSummaryV5 = OrderCostSummaryV4;

export default OrderCostSummaryV5;
